import type { PropsWithChildren } from 'react';
import {
  type FeatureFlagModeProps,
  FeatureFlagsContextProvider,
} from '@frameio/feature-flags';
import { useActiveAccountId } from '../contexts/ActiveEntitiesContext';

export const FeatureFlagsContextProviderWrapper = (
  props: PropsWithChildren<FeatureFlagModeProps>
) => {
  const activeAccountId = useActiveAccountId();
  return <FeatureFlagsContextProvider accountId={activeAccountId} {...props} />;
};
